import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, computed, useSlots } from 'vue'
import {
  formatReviewStatusCountLabel,
  formatReviewStatusLabel,
  reviewStatusChipClasses,
} from '~/functions/review'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusChip',
  props: {
    status: null,
    label: null,
    count: null
  },
  setup(__props: any) {

const props = __props as {
  status: string
  /** Override the default status label from this component's i18n. */
  label?: string
  /** When set, renders "{count} {label}" (aggregate progress). */
  count?: number
};



const slots = useSlots()
const { proxy } = getCurrentInstance()!

const resolvedLabel = computed(() => {
  if (props.label != null && props.label !== '') {
    return props.label
  }
  if (slots.default) {
    return undefined
  }
  const t = proxy.$t.bind(proxy)
  if (props.count != null) {
    return formatReviewStatusCountLabel(props.status, t)
  }
  return formatReviewStatusLabel(props.status, t)
})

return { __sfc: true,props, slots, proxy, resolvedLabel, reviewStatusChipClasses }
}

})